import { PropTypes } from "prop-types";
import { Box, Stack, TextField } from "@mui/material";
import { useCallback } from "react";
import { ALPHANUMERIC_REGEX, NUMERIC_REGEX } from "src/constants";

const CharacterCount = ({ count, helperText, max }) => (
    <Stack direction="row" justifyContent={helperText ? 'space-between' : 'flex-end'} whiteSpace="nowrap">
        <Box overflow="hidden" textOverflow="ellipsis">
            {helperText}
        </Box>
        <Box sx={{ display: count >= 0.9 * max ? 'block' : 'none' }} color={count > max ? 'error.main' : undefined}>
            {count} / {max}
        </Box>
    </Stack>
);

const MapItTextField = ({ handleChange, error, children, containerProps, alphanumeric, numeric, ...props }) => {

    const onChange = useCallback((e) => {
        if (e.target.value === "") {
            handleChange(e)
        }
        if (numeric && (!NUMERIC_REGEX.test(e.target.value))) {
            return
        }
        if (alphanumeric && (e.target.value === "" || !ALPHANUMERIC_REGEX.test(e.target.value))) {
            return
        }
        handleChange(e)
    }, [alphanumeric, numeric, handleChange])

    return (<Box {...containerProps}>
        <TextField
            fullWidth
            onChange={onChange}
            error={Boolean(error)}
            helperText={
                props?.inputProps?.maxLength
                    ? <CharacterCount count={props?.value?.length} helperText={error} max={props?.inputProps?.maxLength} />
                    : error
            }
            InputLabelProps={{
                sx: {
                    color: "text.placeholder",
                },
                shrink: Boolean(props.value)
            }}
            {...props}
        >
            {children}
        </TextField>
    </Box>
    )
}

MapItTextField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    //required: PropTypes.bool.isRequired,
    value: PropTypes.any.isRequired,
    error: PropTypes.string,
    type: PropTypes.string,
    variant: PropTypes.string
};

export default MapItTextField;